import { Component, signal } from '@angular/core';
import { SensorTypeFormComponent } from "@app/components/forms/sensor-type/form.component";
import { SensorTypeHelperService } from '@app/services/helpers/sensor-type-helper.service';
import { Router, RouterModule } from '@angular/router';
import { AppHttpError } from '@app/interfaces/pg-models.interface';
import { SensorTypeCreate } from '@app/models/sensor-type.interface';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { HeadMetaComponent } from '@app/components/ui.component';
import { ToastService } from '@app/services/toast.service';
import { HelpButtonComponent } from "@app/components/help-button/help-button.component";

@Component({
    selector: 'app-sensor-type-create',
    templateUrl: './create.page.html',
    styleUrl: './create.page.scss',
    imports: [
        HeadMetaComponent,
        SensorTypeFormComponent,
        RouterModule,
        FontAwesomeModule,
        HelpButtonComponent
    ]
})
export class SensorTypeCreatePage {
  public title = 'New Sensor Type';
  formValid = signal(false);
  formValue = signal<SensorTypeCreate | null>(null);

  faArrowLeft = faArrowLeft;

  constructor(
    private deviceStatusService: SensorTypeHelperService,
    private router: Router,
    private toast: ToastService,
  ) {
    
  }

  create() {
    let val = this.formValue();
    if(val) {
      this.deviceStatusService.create(val)
        .subscribe({
          next: id => {
            console.log(id)
            if(id) {
              this.router.navigateByUrl('/sensor-types/' + id);
            }
          },
          error: (err: AppHttpError) => {
            console.log(err.error)
            this.toast.message({ message: err.error.code + ": " + err.error.message, type: 'error'});
          }
        });
    }
  }
}
